import React from 'react'
import Botao from '../../../Mantine/Botao/index.jsx'
import Group from '../../../Mantine/Group/index.jsx'
import Modal from '../../../Mantine/Modal/index.jsx'
import * as S from './styles.js'

export default function Alerta({ carrierName, opened, onClose, onConfirm }) {
  const message = `O plano selecionado permite somente a operadora ${carrierName.charAt(0).toUpperCase() + carrierName.slice(1).toLowerCase()}. Deseja remover as linhas das outras operadoras?`

  return (
    <div>
      <Modal
        titulo="Atenção!"
        width={'450px'}
        type="alerta"
        opened={opened}
        positionTitle="center"
      >
        <S.ModalAlert>
          <p className="modal-alert">{message}</p>
          <Group position="center">
            <Botao label="Fechar" variant="outline" onClick={onClose} />
            <Botao label="Confirmar" onClick={onConfirm} />
          </Group>
        </S.ModalAlert>
      </Modal>
    </div>
  )
}
